import React from 'react';
import { useMarketingEmailProviders } from '../hooks/use-marketing-email-providers.js';
import MarketingEmailProvidersPageView from './marketing-email-providers-page-view.jsx';

function MarketingEmailProvidersPageContainer() {
  const state = useMarketingEmailProviders();
  return <MarketingEmailProvidersPageView {...state} />;
}

export default MarketingEmailProvidersPageContainer;
